import { render, staticRenderFns } from "./GlobalSideNav.vue?vue&type=template&id=399c7bad&"
import script from "./GlobalSideNav.vue?vue&type=script&lang=js&"
export * from "./GlobalSideNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports